import TextField from "@mui/material/TextField";
import styled from "styled-components";
import { ErrorMessage } from "./FormHelper.styles";
import { HXMobileButton } from "./HXButton";
import { TextContainer } from "./HXMobilePage.styles";
import { HXCheckbox } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const FullScreenButton = styled(HXMobileButton) `
    width: 100%;
`;
const footerGap = "16px";
export const ConfirmPatientNameFooter = styled(TextContainer) `
    padding: 0 16px 16px 16px;
    gap: ${footerGap};
`;
export const PatientInfoContainer = styled(FlexColumnDiv) `
    display: flex;
    padding: 0;
    justify-content: center;
    align-items: flex-start;
    gap: ${footerGap};
    align-self: flex-start;
`;
export const PatientInfoInnerContainer = styled(FlexColumnDiv) `
    padding: 0;
    gap: 4px;
    align-items: flex-start;
`;
export const PatientNameTextField = styled(TextField) `
    align-self: stretch;
`;
export const PatientSigningReasonCheckbox = styled(HXCheckbox) `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-self: stretch;

    .MuiCheckbox-root {
        padding: 0;
        margin: 0 9px 0 0;
        border-radius: 0;
    }

    .MuiFormControlLabel-label {
        margin-top: 1px;
    }
`;
export const PatientSigningReasonError = styled(ErrorMessage) `
    margin-top: -${footerGap};
`;
